import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import HeroContent from '~/components/hero/HeroContent';

import Image from '~/components/base/Image';

import { AcfLink, AcfBackgroundColor } from '~/utilities/propTypes';
import { calcVw } from '~/styles/helpers';

const BackgroundImage = styled(Image)`
    position: absolute;
    width: ${calcVw(100)};
    top: 0;
    left: 50%;
    right: 50%;
    bottom: 0;
    margin: 0 ${calcVw(-50)};
    z-index: ${({ theme }) => theme.zIndex.backgroundImage};
`;

const PhotoTextBox = ({
    backgroundImage = null,
    backgroundColor = 'black',
    title,
    copy = '',
    ctasVariant = 'ctas',
    ctas = [],
    appLinks = []
}) => (
    <>
        {backgroundImage ? (
            <BackgroundImage {...backgroundImage} objectPosition="top" />
        ) : null}

        <HeroContent
            contentTextBox
            contentPlacement="center"
            columnSpan={6}
            {...{
                backgroundColor,
                title,
                copy,
                ctasVariant,
                ctas,
                appLinks
            }}
        />
    </>
);

PhotoTextBox.propTypes = {
    ...AcfBackgroundColor,
    backgroundImage: PropTypes.shape({}),
    title: PropTypes.string.isRequired,
    copy: PropTypes.string,
    ctasVariant: PropTypes.string,
    ctas: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.string,
            link: AcfLink
        })
    ),
    appLinks: PropTypes.arrayOf(
        PropTypes.shape({
            linkUrl: PropTypes.string,
            badge: PropTypes.shape({})
        })
    )
};

export default PhotoTextBox;
